var _rect, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgM24(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_5440_45577",
    transform: "scale(0.0208333)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_5440_45577",
    width: 48,
    height: 48,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAACXBIWXMAAAsTAAALEwEAmpwYAAACKUlEQVRo3u2aS0sCURiGZ2GriDa6al1URC007WLRWsfCdhEKQn+g9oJlUZv+RNAuCwqi+6pVF6Nl0U5RiAhaJFSCvZ+NNNik4+WM81kHno3O4n3OjOM533ck6X98j5fz9lbgBDNgHoQV5pXP6LtW0wTuihxKp7ujAwgVBZfgA+TK8KFcG33e7Bh49EwYH7wncmgBQXC9vjGX0xFak6e1zlxadl+DALAID967dEzhp8A9yBG1CXSRQIE7MJXyjgubdSuIFYILECgQA9Z6h3eCRHF4QQJEAjjrFd4HMlrhBQoQr0CuR/j338ILFiDeqpZAOFepmTdIgMhU/DghmA0ky4U3SIBIApuu8N2RIxLY0RPeQAFiJ+Ub0zX703rDGyxA+MuFbwEPJhZ4AC2lBEKVhG+AABHSXiZgYYZAtwwEblOecc3Zd1QavkEChF1LYI2RwKqWwA0jgXhx+DaQZSSQBW1qgaFqwjdQgBhSC8wyFJhVCywwFFhQC4QZCoSbSoD9I8T+R8z+Ncr7j0yRiLNdSigCq9wXc3ZGAo6fm/mvuiePDY3sbsItZVNs6hUJv4kFpsvXhRYPSGLbjIWttNf9B0qLRT2BV5MUd13VVqhl8Nbg8rqv1h6BXOpOCBTI1BxeJTHItsVU1OTbMqjJZ5NEjL7oPolMgjsBAvf5Nqtn1LBGdwBc1UGAGt1BQxrdP+7Iyol0tjfSrxw1uKjwqMFy/qjB5PD/YQ/W4xM+u2u3Jb+s9gAAAABJRU5ErkJggg=="
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgM24);
export default __webpack_public_path__ + "static/media/m24.8348d8824d4599b85bdbfecf0d016efd.svg";
export { ForwardRef as ReactComponent };